<header class="header--page">
    <ul class="header__nav">
        <li>
            <h1>API Requests</h1>
        </li>
        <li>
        </li>
    </ul>
</header>

<div class="mvd_container mvd_container--pdf">
    <div class="well">
        <h2>API Request Headers</h2>
        <textarea class="mvd_form-control" rows="20" cols="155">{{headers}}</textarea>
    </div>
</div>
